import { useCallback, useState } from 'react'

export const useToggle = (initialState = false) => {
  const [isToggled, setIsToggled] = useState(initialState)

  const onToggle = useCallback((): void => setIsToggled(prev => !prev), [])

  const onClose = useCallback((): void => setIsToggled(false), [])

  const onOpen = useCallback((): void => setIsToggled(true), [])

  return { isToggled, onToggle, onClose, onOpen, setIsToggled }
}
